import { isRouteErrorResponse, useRouteError, useNavigate } from "react-router-dom"

const ErrorPage = () => {
  const error = useRouteError()
  const navigate = useNavigate()

  const status = isRouteErrorResponse(error) ? error.status : 500

  const message =
    status === 404
      ? "요청한 페이지를 찾을 수 없습니다."
      : status === 403
        ? "접근 권한이 없습니다."
        : "페이지를 불러오는 중 오류가 발생했습니다."

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4">
      <p className="text-2xl font-semibold">{status}</p>
      <p className="text-gray-500">{message}</p>

      <button type="button" onClick={() => navigate(-1)} className="rounded-md border px-4 py-2">
        이전 페이지
      </button>
    </div>
  )
}

export default ErrorPage
